export default __webpack_public_path__ + "static/media/tile001.e766c60d.png";